export default __webpack_public_path__ + "static/media/password.2e14a529.svg";